import { PrivateRoute } from '../Routers/PrivateRoute'
import React from 'react'

//Users app
import AppUsers from '../Components/Admin/Catalogs/AppUsers/AppUsers'
import AppUsersNew from '../Components/Admin/Catalogs/AppUsers/AppUsersNew'
//App User Roles
import AppUserRoles from '../Components/Admin/Catalogs/AppUserRoles/AppUserRoles'
import AppUserRolesNew from '../Components/Admin/Catalogs/AppUserRoles/AppUserRolesNew'

//CONFIG APP
import ConfigApp from '../Components/ConfigApp/ConfigApp'
import ConfigAppNew from '../Components/ConfigApp/ConfigAppNew'
import ConfigAppPages from '../Components/ConfigApp/Pages/ConfigAppPages'
import ConfigAppPagesNew from '../Components/ConfigApp/Pages/ConfigAppPagesNew'

import { ReportPowerBI as ReportPowerBISubmodule } from '../Components/Admin/Catalogs/ReportsPowerBI/ReportPowerBI'

//Report Groups
import ReportGroups from '../Components/ReportGroups/ReportGroups'
import ReportGroupsNew from '../Components/ReportGroups/ReportGroupsNew'
import ReportCategories from '../Components/ReportGroups/ReportCategories'
import ReportCategoriesNew from '../Components/ReportGroups/ReportCategoriesNew'
import ReportSubCategories from '../Components/ReportGroups/ReportSubCategories'
import ReportSubCategoriesNew from '../Components/ReportGroups/ReportSubCategoriesNew'



const submoduleRoutesGenerator = (
  read,
  create,
  edit,
  imports,
  module,
  isAuth
) => {
  const components = {
    //Users app
    AppUsers,
    AppUsersNew,
    //App User Roles
    AppUserRoles,
    AppUserRolesNew,
    //CONFIG APP
    ConfigApp,
    ConfigAppNew,
    ConfigAppPages,
    ConfigAppPagesNew,

    //REPORT POWER BI
    ReportPowerBISubmodule,

    //CRUD groups, categories and subcategories
    ReportGroups,
    ReportGroupsNew,
    ReportCategories,
    ReportCategoriesNew,
    ReportSubCategories,
    ReportSubCategoriesNew,
  }
  let routesArray = []
  if (create) {
    routesArray.push(
      <PrivateRoute
        exact
        path={`${module?.module_info?.relative_link}${module?.submodule_info?.relative_link}/new`}
        component={components[`${module?.submodule_info?.name}New`]}
        isAuth={isAuth}
      />
    )
  }
  if (read) {
    routesArray.push(
      <PrivateRoute
        exact
        path={`${module?.module_info?.relative_link}${module?.submodule_info?.relative_link}`}
        component={components[module?.submodule_info?.name]}
        isAuth={isAuth}
      />
    )
    routesArray.push(
      <PrivateRoute
        exact
        path={`${module?.module_info?.relative_link}${module?.submodule_info?.relative_link}/details/:id/:show`}
        component={components[`${module?.submodule_info?.name}New`]}
        isAuth={isAuth}
      />
    )
  }
  if (edit) {
    routesArray.push(
      <PrivateRoute
        exact
        path={`${module?.module_info?.relative_link}${module?.submodule_info?.relative_link}/edit/:id`}
        component={components[`${module?.submodule_info?.name}New`]}
        isAuth={isAuth}
      />
    )
    if (imports) {
      routesArray.push(
        <PrivateRoute
          exact
          key={module.id}
          path={`${module?.module_info?.relative_link}/import/:form`}
          component={components[`${module?.module_info?.name}New`]}
          isAuth={isAuth}
        />
      )
    }
  }
  return routesArray
}
export default submoduleRoutesGenerator
